<template>
  <PageTemplate>
    <h1>All Pending Registrations</h1>
    <div class="row">
      <div class="col-xl-12">
        <v-card title="Pending Registrations">
          <v-table
            :table="pendingRegistrations"
          />
        </v-card>
      </div>
    </div>
  </PageTemplate>
</template>
<script>
  import PageTemplate from "@/templates/Page";
  import Card from "@/molecules/Card";
  import Table from "@/molecules/Table";
  import {buildBreadCrumb, columnSort, columnFilter} from "@/common/tableFunctions"
  import { mapState } from "vuex";
  import {GET_USER_REQUEST} from "../../store/actions.type";
  import routes from "@/common/routes";

  export default {
    name: "PendingRegistrationAll",
    components: {
      "v-card": Card,
      "v-table": Table,
      PageTemplate
    },
    data: () => ({
      pendingRegistrations: {
        columns: [
          {
            label: 'Name',
            field: 'name',
            sortFn: columnSort,
            thClass: 'sortable',
            link: true,
            filterOptions: {
              enabled: true,
              placeholder: 'User Name',
              filterFn: columnFilter
            },
          },
          {
            label: 'Role',
            field: 'role',
            sortFn: columnSort,
            thClass: 'sortable',
            filterOptions: {
              enabled: true,
              placeholder: 'Role',
              filterFn: columnFilter
            },
          }
        ],
        rows: []
      },
    }),
    computed:{
      ...mapState({
        registrations: state => state.userRequest.registrations,
      })
    },
    mounted() {
      this.updateBreadCrumb();
      this.updateTable();
    },
    methods: {
      updateBreadCrumb: function () {
        let breadcrumbs = [];
        breadcrumbs['Outstanding Activities'] = routes.ADMIN.OUTSTANDING_ACTIVITIES;
        breadcrumbs['All Pending Registrations'] = '';
        this.breadcrumbs = buildBreadCrumb(breadcrumbs);
        this.$store.dispatch('updateBreadCrumbAction', buildBreadCrumb(breadcrumbs));
      },
      updateTable: function(){
        this.$store.dispatch(GET_USER_REQUEST).then(response => {
          this.pendingRegistrations.rows = this.registrations;
        })
      },
    }
  }
</script>

